import { Breakpoint, useMediaQuery, useTheme } from '@mui/material';

export default (breakpoints: Partial<Record<Breakpoint, any>>) => {
	const theme = useTheme();

	return theme.breakpoints.keys
		.reverse()
		.find(
			(breakpointKey: Breakpoint) =>
				breakpoints[breakpointKey] !== undefined &&
				useMediaQuery(theme.breakpoints.down(breakpointKey)),
		);
};
